import { useState } from 'react';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import Header from '@/component/Header';
import CoinTypeForm from '@/component/stake-db/coin-type/CoinTypeForm';
import CoinTypeList from '@/component/stake-db/coin-type/CoinTypeList';

export default function StakeDbCoinType() {
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreated = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', sm: '0px' },
      }}
    >
      <Card>
        <Header title="Stake-db 코인타입 관리" />
        <Divider />
        <CardContent
          sx={{
            maxHeight: '80vh',
            overflow: 'auto',
          }}
        >
          <CoinTypeForm onCreated={handleCreated} />
          <Box mb={4} />
          <Divider />
          <Box mt={4} />
          <Typography variant="h6" sx={{ p: 2, pb: 0 }}>
            코인타입 리스트
          </Typography>
          <CoinTypeList refreshKey={refreshKey} />
        </CardContent>
      </Card>
    </Box>
  );
}
